module.exports = __webpack_public_path__ + "img/pessahFlyer.f9fc5f61.png";